import Swiper from 'swiper'

import { select } from '@js/util/select'
import swiperHandleKeyboardFocus from '@js/util/swiper-handle-keyboard-focus'

select('.wpce-swiper', swiperElement => {
  swiperElement.classList.remove('not-initialized')
  let swiper = new Swiper(`#${swiperElement.dataset.swiperId}`, {
    // Optional parameters
    direction: 'horizontal',
    loop: false,
    slidesPerView: 'auto',
    spaceBetween: 20,
    threshold: 5,
    centeredSlides: false,

    // If we need pagination
    pagination: false,
    breakpoints: {
      0: {
        spaceBetween: 20,
      },
      540: {
        spaceBetween: 24,
      },
      768: {
        spaceBetween: 32,
      },
    },
  })

  if (swiperElement.dataset.swiperSlide) {
    swiper.slideTo(Number(swiperElement.dataset.swiperSlide))
  }

  // Keyboard focus is not handled by Swiper.js itself
  swiperHandleKeyboardFocus(swiper)

  // Handle previous button
  function onPrevClick() {
    swiper.slideTo(swiper.activeIndex - 1)
  }
  let prevButton = swiperElement.querySelector('.custom-button-prev')
  prevButton?.addEventListener('click', onPrevClick)

  // Handle next button
  function onNextClick() {
    swiper.slideTo(swiper.activeIndex + 1)
  }
  let nextButton = swiperElement.querySelector('.custom-button-next')
  nextButton?.addEventListener('click', onNextClick)

  // Handle swiper destroy
  swiper.once('beforeDestroy', () => {
    prevButton?.removeEventListener('click', onPrevClick)
    nextButton?.removeEventListener('click', onNextClick)
  })

  return () => {
    swiper.destroy()
  }
})
